import VisitorProfilesResource from '@/resources/VisitorProfilesResource';

export default class VisitorProfiles {
    constructor() {
        this.Resource = new VisitorProfilesResource()
    }

    async get (options) {
        const visitorProfile = await this.Resource.get(options)
        return visitorProfile.data
    }
}
